const faqs = [
  { q: '夜猫影院真的完全免费吗？', a: '是的，夜猫影院所有电影在线观看完全免费。无需注册账号、无需充值会员，打开浏览器即可畅享高清电影播放。我们致力于打造最纯粹的电影大全免费平台，让每一位影迷都能轻松观影。' },
  { q: '观看需要安装什么软件或插件吗？', a: '完全不需要。夜猫影院是纯网页端平台，使用现代浏览器（推荐 Chrome、Edge、Safari）直接访问即可观看最新电影在线看。无需下载 App、无需安装任何插件或播放器。' },
  { q: '为什么有时候播放会卡顿？', a: '卡顿通常与当前网络环境或所选播放线路有关。夜猫影院为热门电影推荐配置了多条备用线路，建议切换线路尝试。同时我们持续优化 CDN 节点，深夜高峰期的流畅度也在不断提升中。' },
  { q: '影片会更新吗？更新频率如何？', a: '会的！编辑团队每日精选最新资源，每晚 20:00 准时更新热门电影推荐片单。新片上映后通常在 24-48 小时内完成高清版上线。经典影片也会定期补充和画质修复升级。' },
  { q: '手机和平板能看吗？', a: '当然可以。夜猫影院全面适配手机与平板设备，在移动端浏览器中即可享受流畅的高清电影播放体验。界面针对触控操作优化，横竖屏自动适配，被窝里刷片的最佳选择。' },
  { q: '影片的来源是否安全合法？', a: '夜猫影院是一个影迷交流与电影信息分享平台，所有展示内容仅供交流学习。我们尊重知识产权，如果您是版权方且认为某些内容侵犯了您的权益，请通过联系投稿页面与我们沟通，我们将积极配合处理。' },
];

import { useState } from 'react';

export default function SectionFaq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-question-answer-fill text-accent-400 text-xs"></i></span>
            <span className="text-xs text-accent-400 font-medium whitespace-nowrap">常见疑问</span>
          </div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-50 mb-2">常见问题</h2>
          <p className="text-sm text-foreground-400 max-w-lg mx-auto">关于夜猫影院的使用、观影与安全，你想知道的都在这里</p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-lg bg-background-50 border border-background-200/50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === i ? null : i)}
                className="w-full flex items-center justify-between gap-3 p-4 text-left cursor-pointer hover:bg-background-200/30 transition-colors"
              >
                <h3 className="text-sm font-medium text-foreground-100 pr-4">{faq.q}</h3>
                <span className={`w-5 h-5 flex-shrink-0 flex items-center justify-center transition-transform duration-200 ${openIdx === i ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-400"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIdx === i ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-4 text-xs text-foreground-300 leading-relaxed">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}